export default function CheckboxSelector({
  list = [],
  onItemCheck,
  checkedList,
  slug = 'year',
  multiSelect = true,
}) {
  const handleItemCheck = (e, year = null) => {
    const item = e.target.value;
    if (slug === 'quarters') {
      year = list.find((l) => l.title === year).completeYear;
      const foundFinancialYr = checkedList.find(
        (l) => l.financial_year === year,
      );

      if (foundFinancialYr) {
        // if quarter found
        const foundQuarter = foundFinancialYr.quarters.some((q) => q === item);
        if (foundQuarter) {
          const updatedQuarters = foundFinancialYr.quarters.filter(
            (q) => q !== item,
          );

          //   if some quarters are selected
          if (updatedQuarters.length) {
            const updatedList = checkedList.map((obj) =>
              obj.financial_year === year
                ? { ...obj, quarters: updatedQuarters }
                : obj,
            );
            onItemCheck(updatedList);

            //   if some quarters are not selected
          } else {
            const updatedList = checkedList.filter(
              (obj) => obj.financial_year !== year,
            );
            onItemCheck(updatedList);
          }
          // if quarter not found
        } else {
          const updatedList = checkedList.map((obj) =>
            obj.financial_year === year
              ? { ...obj, quarters: [...obj.quarters, item] }
              : obj,
          );
          onItemCheck(updatedList);
          return;
        }

        // if any quaters from financial year is not selected
      } else {
        const newData = {
          financial_year: year,
          quarters: [item],
        };
        onItemCheck([...checkedList, newData]);
      }
    } else if (slug === 'months') {
      if (checkedList.some((ci) => ci.title === item)) {
        const updatedList = checkedList.filter((l) => l.title !== item);
        onItemCheck(updatedList);
      } else {
        const newItem = list.months.find((l) => l.title === item);
        onItemCheck([...checkedList, newItem]);
      }
    } else {
      if (multiSelect) {
        if (checkedList.some((ci) => ci.title === item)) {
          const updatedList = checkedList.filter((l) => l.title !== item);
          onItemCheck(updatedList);
        } else {
          const newItem = list.find((l) => l.title === item);
          onItemCheck([...checkedList, newItem]);
        }
      } else {
        const newItem = list.find((l) => l.title === item);
        onItemCheck([newItem]);
      }
    }
  };

  return slug === 'year' ? (
    <div className="rounded-lg bg-secondary-bg flex flex-col gap-2 justify-center font-['SF-Pro-Text-Regular, sans-serif']  text-tertiary-text border border-[#E1E1E1]">
      {list.map((item) => {
        return (
          <div
            key={item.title}
            className="py-1.5 px-2.5 font-medium text-xs flex items-center gap-2 cursor-pointer"
          >
            <input
              type="checkbox"
              id={item.title}
              className="checked:border-primary-bg-tint checked:ring-primary-bg-tint checked:ring-1 checked:accent-secondary-bg checked:w-2.5 w-3 h-3 checked:h-2.5 !rounded-lg checked:text-primary-bg-tint"
              checked={checkedList.some((ci) => ci.title === item.title)}
              onChange={handleItemCheck}
              value={item.title}
            />
            <label htmlFor={item.title} className="cursor-pointer">
              {item.shortHand}
            </label>
          </div>
        );
      })}
    </div>
  ) : slug === 'quarters' ? (
    list.map((item) => {
      return (
        <div
          key={item.title}
          className="rounded-lg bg-secondary-bg flex flex-col gap-2 justify-center font-['SF-Pro-Text-Regular, sans-serif']  text-tertiary-text border border-[#E1E1E1]"
        >
          <label className="font-['SF-Pro-Text-Regular, sans-serif'] py-1 px-2.5 text-xs font-medium">
            {item.title}
          </label>

          {item.quarters.map((q) => {
            return (
              <div
                key={q.title}
                className="py-1.5 px-2.5 font-medium text-xs flex items-center gap-2 cursor-pointer"
              >
                <input
                  type="checkbox"
                  id={q.title}
                  className="checked:border-primary-bg-tint checked:ring-primary-bg-tint checked:ring-1 checked:accent-secondary-bg checked:w-2.5 w-3 h-3 checked:h-2.5 !rounded-lg checked:text-primary-bg-tint"
                  checked={checkedList
                    .flatMap((i) => i.quarters)
                    .some((ci) => ci === q.completeQuarter)}
                  onChange={(e) => handleItemCheck(e, item.title)}
                  value={q.completeQuarter}
                />
                <label htmlFor={q.title} className="cursor-pointer">
                  {q.title}
                </label>
              </div>
            );
          })}
        </div>
      );
    })
  ) : slug === 'months' ? (
    <div className="rounded-lg bg-secondary-bg flex flex-col gap-2 justify-center font-['SF-Pro-Text-Regular, sans-serif']  text-tertiary-text border border-[#E1E1E1]">
      {list.months.map((item) => {
        return (
          <div
            key={item.title}
            className="py-1.5 px-2.5 font-medium text-xs flex items-center gap-2 cursor-pointer"
          >
            <input
              type="checkbox"
              id={item.title}
              className="checked:border-primary-bg-tint checked:ring-primary-bg-tint checked:ring-1 checked:accent-secondary-bg checked:w-2.5 w-3 h-3 checked:h-2.5 !rounded-lg checked:text-primary-bg-tint"
              checked={checkedList.some((ci) => ci.title === item.title)}
              onChange={handleItemCheck}
              value={item.title}
            />
            <label htmlFor={item.title} className="cursor-pointer">
              {item.title}
            </label>
          </div>
        );
      })}
    </div>
  ) : null;
}
